// PDF presigned-URL helper. Cross-section: scope, controls, and cuecs all
// need to deep-link into a page in the source PDF.
import { api } from "./client";

export async function getPdfUrl(reportId: string): Promise<string> {
  const data = await api.get<{ url: string }>(`/reports/${reportId}/pdf-url`);
  return data.url;
}

export async function openPdfAtPage(reportId: string, page: number): Promise<void> {
  const url = await getPdfUrl(reportId);
  window.open(`${url}#page=${page}`, "_blank", "noopener,noreferrer");
}
